(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('KiosksDashboardDeleteController',KiosksDashboardDeleteController);

    KiosksDashboardDeleteController.$inject = ['$uibModalInstance', 'entity', 'KiosksDashboards'];

    function KiosksDashboardDeleteController($uibModalInstance, entity, KiosksDashboards) {
        var vm = this;
        vm.dashboard = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            KiosksDashboards.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
